var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Meine Filialen")]),_c('store-list'),_c('a',{attrs:{"href":"config"}},[_vm._v("weitere Filiale hinzufügen")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }